// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cms-form-page',
    // #endregion
    // #region Props
    props: {
        formName: {
            type: String,
            required: false,
            default: ''
        }
    },
    // #region Data
    data: () => ({
        _schema: {},
        _data: null
    }),
    // #endregion
    // #endregion
    // #region Constructor
    created() {
        this.loadSchema();
    },
    // #endregion
    // #region Watch
    'formName': function (value) {
        this.loadSchema();
    },
    // #endregion
    // #region Computed
    computed: {
        showCommandBar() {
            return this.$route.meta.showCommandBar ?? true;
        }
    },
    // #endregion
    // #region Core
    methods: {
        // #region CRUD            
        async loadSchema() {
            // #region Check
            if (utils.isNullOrEmpty(this.formName)) {
                return;
            }
            // #endregion
            // #region Load
            try {
                //Get
                let tResult = await host.cache.getOrCreateAsync("cms.form." + this.formName, () => this.loadSchemaCore());
                //Set
                this._schema = tResult;
                //Data
                this.loadData();
            }
            catch (e) {
                host.notification.showError(e);
            }
            // #endregion
        },
        async loadSchemaCore() {
            return await (await host.api.get(`cms/pages/${this.formName}`)).data;
        },
        async loadData() {
            // #region Check
            if (!this._schema) {
                return;
            }
            if (!this._schema?._links?.data?.href) {
                return;
            }
            // #endregion
            // #region Load
            try {
                let tData = await host.api.request({
                    url: this._schema._links.data.href,
                    method: this._schema._links.data.method ?? 'GET'
                });
                if (tData.data) {
                    this._data = tData.data;
                }
            }
            catch (e) {
                host.notification.showError(e);
            }
            // #endregion
        },
        // #endregion
        // #region Commands
        OnRefresh(event) {
            //Default
            event?.preventDefault();
            //Notify
            this.loadData();
        },
        // #endregion
    },
    // #endregion
});
// #endregion
